const ExponentOperator = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" width="13" height="13">
            <path fill="none" stroke="currentColor" strokeLinecap="square" d="M3 7l3.5-3.5L10 7"></path>
        </svg>
    )
}
export default ExponentOperator